export const environment = {
  production: true,
  version: '3a334d0656',
  site_version: 'SITE_VERSION'
};
